import React from 'react';

import Layout from '@/components/Layout';

import * as S from './style';

const TemplateQuemSomos = () => {
  return (
    <Layout>
      <S.Container>
        <h2>Quem Somos</h2>
        <p>
          A BORA TICKETS é uma empresa de base tecnológica que atende tanto
          organizadores (B2B) como compradores (B2C), oferecendo serviços para a
          gestão de eventos e compra de ingressos. O público encontra uma ampla
          variedade de opções, desde grandes shows, festas e eventos esportivos
          até congressos, cursos, encontros de networking, dentre outros.
        </p>
        <p>
          A empresa nasceu em 2018, em Salvador-BA, fruto de parceria com as
          produtoras Salvador Producões e Pida!
        </p>
      </S.Container>
    </Layout>
  );
};

export default React.memo(TemplateQuemSomos);
